var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNote(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iconNote_svg__clip0_711_1261)",
    stroke: "#879494",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5h5M7.5 10h5M7.5 12.5H10M12.242 16.875H3.75a.625.625 0 01-.625-.625V3.75a.625.625 0 01.625-.625h12.5a.625.625 0 01.625.625v8.492a.615.615 0 01-.18.438l-4.015 4.015a.615.615 0 01-.438.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.82 12.5H12.5v4.32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconNote_svg__clip0_711_1261"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNote);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconNote.358d8521.svg";
export { MemoForwardRef as ReactComponent };